// extracted by mini-css-extract-plugin
export default {"column":"ConferenceDetailsComponent_column__Cx7W-","body":"ConferenceDetailsComponent_body__h00gU"};